module.exports = __webpack_public_path__ + "static/media/logo-vue.cf86d7c9.png";